// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://hqfjhwbzehiacoekvrya.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhxZmpod2J6ZWhpYWNvZWt2cnlhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjgzODM2ODksImV4cCI6MjA4Mzk1OTY4OX0.Oe-HTK6A0TXkNcw29OAbhGUjaQ1zWb1zXzuCw2ia5Wk";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});